import EditJobContainer from '../../vacancy/containers/EditJobContainer';

const EditJobPage = () => {
  return <EditJobContainer />;
};

export default EditJobPage;
